function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// src/signals/vac-conversation-created-signal.ts
import { Signal } from "@shared-ui/core-signal-manager/spi";
var VacConversationCreatedSignal = /*#__PURE__*/function (_Signal) {
  function VacConversationCreatedSignal() {
    _classCallCheck(this, VacConversationCreatedSignal);
    return _callSuper(this, VacConversationCreatedSignal, arguments);
  }
  _inherits(VacConversationCreatedSignal, _Signal);
  return _createClass(VacConversationCreatedSignal);
}(Signal);

// src/signals/vac-conversation-create-fail-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var VacConversationCreateFailedSignal = /*#__PURE__*/function (_Signal2) {
  function VacConversationCreateFailedSignal() {
    _classCallCheck(this, VacConversationCreateFailedSignal);
    return _callSuper(this, VacConversationCreateFailedSignal, arguments);
  }
  _inherits(VacConversationCreateFailedSignal, _Signal2);
  return _createClass(VacConversationCreateFailedSignal);
}(Signal2);

// src/signals/vac-chat-window-visible-signal.ts
import { Signal as Signal3 } from "@shared-ui/core-signal-manager/spi";
var VacChatWindowVisibleSignal = /*#__PURE__*/function (_Signal3) {
  function VacChatWindowVisibleSignal() {
    _classCallCheck(this, VacChatWindowVisibleSignal);
    return _callSuper(this, VacChatWindowVisibleSignal, arguments);
  }
  _inherits(VacChatWindowVisibleSignal, _Signal3);
  return _createClass(VacChatWindowVisibleSignal);
}(Signal3);

// src/signals/vac-chat-message-sent-signal.ts
import { Signal as Signal4 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageSentSignal = /*#__PURE__*/function (_Signal4) {
  function VacChatMessageSentSignal() {
    _classCallCheck(this, VacChatMessageSentSignal);
    return _callSuper(this, VacChatMessageSentSignal, arguments);
  }
  _inherits(VacChatMessageSentSignal, _Signal4);
  return _createClass(VacChatMessageSentSignal);
}(Signal4);

// src/signals/vac-chat-message-send-failed-signal.ts
import { Signal as Signal5 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageSendFailedSignal = /*#__PURE__*/function (_Signal5) {
  function VacChatMessageSendFailedSignal() {
    _classCallCheck(this, VacChatMessageSendFailedSignal);
    return _callSuper(this, VacChatMessageSendFailedSignal, arguments);
  }
  _inherits(VacChatMessageSendFailedSignal, _Signal5);
  return _createClass(VacChatMessageSendFailedSignal);
}(Signal5);

// src/signals/vac-initialization-error-signal.ts
import { Signal as Signal6 } from "@shared-ui/core-signal-manager/spi";
var VacInitializationErrorSignal = /*#__PURE__*/function (_Signal6) {
  function VacInitializationErrorSignal() {
    _classCallCheck(this, VacInitializationErrorSignal);
    return _callSuper(this, VacInitializationErrorSignal, arguments);
  }
  _inherits(VacInitializationErrorSignal, _Signal6);
  return _createClass(VacInitializationErrorSignal);
}(Signal6);

// src/signals/vac-reconnect-signal.ts
import { Signal as Signal7 } from "@shared-ui/core-signal-manager/spi";
var VacReconnectSignal = /*#__PURE__*/function (_Signal7) {
  function VacReconnectSignal() {
    _classCallCheck(this, VacReconnectSignal);
    return _callSuper(this, VacReconnectSignal, arguments);
  }
  _inherits(VacReconnectSignal, _Signal7);
  return _createClass(VacReconnectSignal);
}(Signal7);

// src/signals/vac-send-message-signal.ts
import { Signal as Signal8 } from "@shared-ui/core-signal-manager/spi";
var VacSendMessageSignal = /*#__PURE__*/function (_Signal8) {
  function VacSendMessageSignal() {
    _classCallCheck(this, VacSendMessageSignal);
    return _callSuper(this, VacSendMessageSignal, arguments);
  }
  _inherits(VacSendMessageSignal, _Signal8);
  return _createClass(VacSendMessageSignal);
}(Signal8);

// src/signals/vac-notification-sound-signal.ts
import { Signal as Signal9 } from "@shared-ui/core-signal-manager/spi";
var VacNotificationSoundSignal = /*#__PURE__*/function (_Signal9) {
  function VacNotificationSoundSignal() {
    _classCallCheck(this, VacNotificationSoundSignal);
    return _callSuper(this, VacNotificationSoundSignal, arguments);
  }
  _inherits(VacNotificationSoundSignal, _Signal9);
  return _createClass(VacNotificationSoundSignal);
}(Signal9);

// src/signals/vac-connected-signal.ts
import { Signal as Signal10 } from "@shared-ui/core-signal-manager/spi";
var VacConnectedSignal = /*#__PURE__*/function (_Signal10) {
  function VacConnectedSignal() {
    _classCallCheck(this, VacConnectedSignal);
    return _callSuper(this, VacConnectedSignal, arguments);
  }
  _inherits(VacConnectedSignal, _Signal10);
  return _createClass(VacConnectedSignal);
}(Signal10);

// src/signals/vac-disconnected-signal.ts
import { Signal as Signal11 } from "@shared-ui/core-signal-manager/spi";
var VacDisconnectedSignal = /*#__PURE__*/function (_Signal11) {
  function VacDisconnectedSignal() {
    _classCallCheck(this, VacDisconnectedSignal);
    return _callSuper(this, VacDisconnectedSignal, arguments);
  }
  _inherits(VacDisconnectedSignal, _Signal11);
  return _createClass(VacDisconnectedSignal);
}(Signal11);

// src/signals/vac-chat-message-received-signal.ts
import { Signal as Signal12 } from "@shared-ui/core-signal-manager/spi";
var VacChatMessageReceivedSignal = /*#__PURE__*/function (_Signal12) {
  function VacChatMessageReceivedSignal() {
    _classCallCheck(this, VacChatMessageReceivedSignal);
    return _callSuper(this, VacChatMessageReceivedSignal, arguments);
  }
  _inherits(VacChatMessageReceivedSignal, _Signal12);
  return _createClass(VacChatMessageReceivedSignal);
}(Signal12);

// src/signals/vac-connect-websocket-signal.ts
import { Signal as Signal13 } from "@shared-ui/core-signal-manager/spi";
var VacConnectWebsocketSignal = /*#__PURE__*/function (_Signal13) {
  function VacConnectWebsocketSignal() {
    _classCallCheck(this, VacConnectWebsocketSignal);
    return _callSuper(this, VacConnectWebsocketSignal, arguments);
  }
  _inherits(VacConnectWebsocketSignal, _Signal13);
  return _createClass(VacConnectWebsocketSignal);
}(Signal13);

// src/signals/vac-start-heartbeat-signal.ts
import { Signal as Signal14 } from "@shared-ui/core-signal-manager/spi";
var VacStartHeartbeatSignal = /*#__PURE__*/function (_Signal14) {
  function VacStartHeartbeatSignal() {
    _classCallCheck(this, VacStartHeartbeatSignal);
    return _callSuper(this, VacStartHeartbeatSignal, arguments);
  }
  _inherits(VacStartHeartbeatSignal, _Signal14);
  return _createClass(VacStartHeartbeatSignal);
}(Signal14);

// src/signals/vac-dynamic-card-signal.ts
import { Signal as Signal15 } from "@shared-ui/core-signal-manager/spi";
var VacDynamicCardSignal = /*#__PURE__*/function (_Signal15) {
  function VacDynamicCardSignal() {
    _classCallCheck(this, VacDynamicCardSignal);
    return _callSuper(this, VacDynamicCardSignal, arguments);
  }
  _inherits(VacDynamicCardSignal, _Signal15);
  return _createClass(VacDynamicCardSignal);
}(Signal15);

// src/signals/vac-fetch-history-messages-fail-signal.ts
import { Signal as Signal16 } from "@shared-ui/core-signal-manager/spi";
var VacFetchHistoryMessagesFailedSignal = /*#__PURE__*/function (_Signal16) {
  function VacFetchHistoryMessagesFailedSignal() {
    _classCallCheck(this, VacFetchHistoryMessagesFailedSignal);
    return _callSuper(this, VacFetchHistoryMessagesFailedSignal, arguments);
  }
  _inherits(VacFetchHistoryMessagesFailedSignal, _Signal16);
  return _createClass(VacFetchHistoryMessagesFailedSignal);
}(Signal16);

// src/signals/vac-participant-events-signal.ts
import { Signal as Signal17 } from "@shared-ui/core-signal-manager/spi";
var VacParticipantEventsSignal = /*#__PURE__*/function (_Signal17) {
  function VacParticipantEventsSignal() {
    _classCallCheck(this, VacParticipantEventsSignal);
    return _callSuper(this, VacParticipantEventsSignal, arguments);
  }
  _inherits(VacParticipantEventsSignal, _Signal17);
  return _createClass(VacParticipantEventsSignal);
}(Signal17);

// src/signals/vac-conversation-read-signal.ts
import { Signal as Signal18 } from "@shared-ui/core-signal-manager/spi";
var VacConversationReadSignal = /*#__PURE__*/function (_Signal18) {
  function VacConversationReadSignal() {
    _classCallCheck(this, VacConversationReadSignal);
    return _callSuper(this, VacConversationReadSignal, arguments);
  }
  _inherits(VacConversationReadSignal, _Signal18);
  return _createClass(VacConversationReadSignal);
}(Signal18);

// src/signals/vac-dynamic-card-webview-signal.ts
import { Signal as Signal19 } from "@shared-ui/core-signal-manager/spi";
var VacDynamicCardWebviewSignal = /*#__PURE__*/function (_Signal19) {
  function VacDynamicCardWebviewSignal() {
    _classCallCheck(this, VacDynamicCardWebviewSignal);
    return _callSuper(this, VacDynamicCardWebviewSignal, arguments);
  }
  _inherits(VacDynamicCardWebviewSignal, _Signal19);
  return _createClass(VacDynamicCardWebviewSignal);
}(Signal19);

// src/signals/vac-external-ibm-conversation-create-signal.ts
import { Signal as Signal20 } from "@shared-ui/core-signal-manager/spi";
var VirtualAgentControlMessageType = /* @__PURE__ */(VirtualAgentControlMessageType2 => {
  VirtualAgentControlMessageType2["FILE"] = "FILE";
  VirtualAgentControlMessageType2["INTENT"] = "INTENT";
  VirtualAgentControlMessageType2["POSTBACK"] = "POSTBACK";
  VirtualAgentControlMessageType2["TEXT"] = "TEXT";
  return VirtualAgentControlMessageType2;
})(VirtualAgentControlMessageType || {});
var VacCreateConversationSignal = /*#__PURE__*/function (_Signal20) {
  function VacCreateConversationSignal() {
    _classCallCheck(this, VacCreateConversationSignal);
    return _callSuper(this, VacCreateConversationSignal, arguments);
  }
  _inherits(VacCreateConversationSignal, _Signal20);
  return _createClass(VacCreateConversationSignal);
}(Signal20);

// src/signals/vac-orchestrator-query-signal.ts
import { Signal as Signal21 } from "@shared-ui/core-signal-manager/spi";
var VacOrchestratorQuerySignal = /*#__PURE__*/function (_Signal21) {
  function VacOrchestratorQuerySignal() {
    _classCallCheck(this, VacOrchestratorQuerySignal);
    return _callSuper(this, VacOrchestratorQuerySignal, arguments);
  }
  _inherits(VacOrchestratorQuerySignal, _Signal21);
  return _createClass(VacOrchestratorQuerySignal);
}(Signal21);

// src/signals/vac-initialization-signal.ts
import { Signal as Signal22 } from "@shared-ui/core-signal-manager/spi";
var VacInitializationSignal = /*#__PURE__*/function (_Signal22) {
  function VacInitializationSignal() {
    _classCallCheck(this, VacInitializationSignal);
    return _callSuper(this, VacInitializationSignal, arguments);
  }
  _inherits(VacInitializationSignal, _Signal22);
  return _createClass(VacInitializationSignal);
}(Signal22);
export { VacChatMessageReceivedSignal, VacChatMessageSendFailedSignal, VacChatMessageSentSignal, VacChatWindowVisibleSignal, VacConnectWebsocketSignal, VacConnectedSignal, VacConversationCreateFailedSignal, VacConversationCreatedSignal, VacConversationReadSignal, VacCreateConversationSignal, VacDisconnectedSignal, VacDynamicCardSignal, VacDynamicCardWebviewSignal, VacFetchHistoryMessagesFailedSignal, VacInitializationErrorSignal, VacInitializationSignal, VacNotificationSoundSignal, VacOrchestratorQuerySignal, VacParticipantEventsSignal, VacReconnectSignal, VacSendMessageSignal, VacStartHeartbeatSignal, VirtualAgentControlMessageType };
//# sourceMappingURL=index.js.map